import React from 'react';
import ReactDOM from 'react-dom';
import App from './container/App';
import './index.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import registerServiceWorker from './registerServiceWorker';
import { MuiThemeProvider } from 'material-ui/styles';
import { darkTheme, defaultTheme } from './themes/themes';
import ChartWrapper from './container/ChartWrapper';
import SankeyWrapper from './container/SankeyWrapper';
import SiteOverview from './container/SiteOverview';
import withTimeSeriesControls from './container/wrapper/WithTimeSeriesControls';
import Auth from './auth';

export const apiBase = window.location.pathname.startsWith('/external/')
  ? 'https://ghub.api.internetofefficiency.com/v2'
  : 'https://api.internetofefficiency.com/v2';
export const apiBaseUrl = window.location.pathname.startsWith('/external/')
  ? 'https://ghub.api.internetofefficiency.com/'
  : 'https://api.internetofefficiency.com/';

export const store = configureStore();
export const clientId = process.env.REACT_APP_CLIENT_ID;

export const { accessToken, redirect } = Auth();

if (redirect) {
  window.location = redirect;
}

export const requestHeaders = accessToken
  ? { Authorization: `Bearer ${accessToken}` }
  : {};

const DefaultLayout = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <MuiThemeProvider theme={defaultTheme}>
          <App
            siteId={matchProps.match.params.siteId}
            {...matchProps}
            external={false}
          >
            <Component {...matchProps} />
          </App>
        </MuiThemeProvider>
      )}
    />
  );
};

const ExternalLayout = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <MuiThemeProvider theme={darkTheme}>
          <App
            siteId={matchProps.match.params.siteId}
            {...matchProps}
            external={true}
          >
            <Component {...matchProps} external={true} />
          </App>
        </MuiThemeProvider>
      )}
    />
  );
};

const RootRoutesProduction = () => (
  <div>
    <Route
      exact
      path="/"
      render={() =>
        (window.location = 'https://connect.internetofefficiency.com')
      }
    />
    <Route
      exact
      path="/sites"
      render={() =>
        (window.location = 'https://connect.internetofefficiency.com/sites')
      }
    />
  </div>
);

const RootRoutesDev = () => (
  <Route
    exact
    path="/"
    render={() =>
      (window.location = 'http://127.0.0.1:3000/sites/58e76d06ce9d0574320000be')
    }
  />
);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <div>
        {process.env.NODE_ENV === 'production'
          ? RootRoutesProduction()
          : RootRoutesDev()}
        <ExternalLayout
          exact
          path="/external/sites/:siteId"
          component={SiteOverview}
        />
        <ExternalLayout
          exact
          path="/external/sites/:siteId/charts"
          component={withTimeSeriesControls(ChartWrapper, 'chart')}
        />
        <ExternalLayout
          exact
          path="/external/sites/:siteId/sankey"
          component={withTimeSeriesControls(SankeyWrapper, 'sankey')}
        />
        <ExternalLayout
          exact
          path="/external/sites/:siteId/sankey/chart/group/:group/filter/:filter"
          component={withTimeSeriesControls(ChartWrapper, 'chart')}
        />
        <ExternalLayout
          exact
          path="/external//sites/:siteId/logger/:loggerId/sankey/chart/group/:group/filter/:filter"
          component={withTimeSeriesControls(ChartWrapper, 'chart')}
        />

        <DefaultLayout exact path="/sites/:siteId" component={SiteOverview} />
        <DefaultLayout
          exact
          path="/sites/:siteId/charts"
          component={withTimeSeriesControls(ChartWrapper, 'chart')}
        />
        <DefaultLayout
          exact
          path="/sites/:siteId/sankey"
          component={withTimeSeriesControls(SankeyWrapper, 'sankey')}
        />
        <DefaultLayout
          exact
          path="/sites/:siteId/logger/:loggerId"
          component={withTimeSeriesControls(ChartWrapper, 'chart')}
        />
        <DefaultLayout
          exact
          path="/sites/:siteId/logger/:loggerId/charts"
          component={withTimeSeriesControls(ChartWrapper, 'chart')}
        />
        <DefaultLayout
          exact
          path="/sites/:siteId/logger/:loggerId/sankey"
          component={withTimeSeriesControls(SankeyWrapper, 'sankey')}
        />
        <DefaultLayout
          exact
          path="/sites/:siteId/sankey/chart/group/:group/filter/:filter"
          component={withTimeSeriesControls(ChartWrapper, 'chart')}
        />
        <DefaultLayout
          exact
          path="/sites/:siteId/logger/:loggerId/sankey/chart/group/:group/filter/:filter"
          component={withTimeSeriesControls(ChartWrapper, 'chart')}
        />
      </div>
    </Router>
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();

/*
<Route path="/sites/:siteId" component={app}/>

    <Route exact path="/" render={() => {
      window.location = 'https://connect.internetofefficiency.com';
    }}/>
    <Route exact path="/sites" render={() => {
      window.location = 'https://connect.internetofefficiency.com/sites';
    }}/>
 */



// WEBPACK FOOTER //
// ./src/index.js